module.exports = __webpack_public_path__ + "img/logo.720d7317.png";